import { useGlobalUnreadListener } from '@avanta/shared/hooks/Chat/useGlobalUnreadListener';
import { Outlet } from 'react-router';
import { Sidebar } from 'components/Layout/Sidebar';
import { Notifications } from './Notifications';

export const Layout = (): React.ReactElement => {
  useGlobalUnreadListener();

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex min-h-0 flex-1 flex-col overflow-x-hidden">
        {/* am-7xl:max-w-424 = 1600px of content + 2 × 48px of padding (border-box) */}
        <main className="am-7xl:max-w-424 am-7xl:p-12 flex-1 p-6">
          <Outlet />
        </main>
        <Notifications />
      </div>
    </div>
  );
};
